import { FC, useState } from 'react';
import { Alert, Box, Button, Grid, Typography } from '@material-ui/core';
import i18n from 'i18next';
import { LoginContainer } from 'src/components/loginContainer';
import { useAppDispatch, useAppSelector } from 'src/hooks/useStore';
import VectorIcon from '../../icons/vectorIcon';
import { check2FA, selectAuth, close2FA } from './authSlice';
import { OtpInput } from 'src/components/otpInput';
import { useNavigate } from 'react-router-dom';

const twoFactorAuthPage: FC = () => {
  const [otp, setOtp] = useState<string>('');

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { error, uuid } = useAppSelector(selectAuth);

  const handleOtpComplete = (code: string) => {
    console.log('Submitted OTP Code:', code);
    setOtp(code);
  };
  
  console.log('uuid :: ', uuid);
  const submitOTP = async () => {
    await dispatch(check2FA({ otp: otp, uuid: uuid }));
  };

  const handlClose2FA = () => {
    dispatch(close2FA());
    navigate('/login');
  };
  
  return (
    <LoginContainer>
        <Box sx={{ alignItems: 'center', display: 'flex', mb: 1 }}>
          <Typography color="textPrimary" variant="h3">
            Code de vérification
          </Typography>
        </Box>
        <Box sx={{ alignItems: 'center', display: 'flex', mb: 3 }}>
          <Typography color="textPrimary" variant="body1">
            Saisissez le code à 6 chiffres reçu par email.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <OtpInput length={6} onComplete={handleOtpComplete} />
          </Grid>
          <Grid item xs={12} style={{ paddingTop: '3vh' }}>
            <Button
              color="primary"
              disabled={otp.length < 6}
              fullWidth
              size="large"
              variant="contained"
              onClick={submitOTP}
            >
              Valider
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              color="primary"
              variant="text"
              startIcon={<VectorIcon />}
              onClick={handlClose2FA}
            >
              Code non reçu ? Recommencer
            </Button>
          </Grid>
        </Grid>
        {error && (
          <Alert severity="error" sx={{ mt: 3 }}>
            {i18n.t(`auth.errors.${error}`)}
          </Alert>
        )}
    </LoginContainer>
  );
};
export default twoFactorAuthPage;
